import { action, observable } from "mobx";
import { ApiService, ApiUrl, Constants } from "helpers";
import Alert from 'react-s-alert';

const emailFooterTemplateStore = observable(
  {
    isFormDirty: false,
    emailFooterTemplate: undefined,
    emailUnsubscribeTemplate: undefined,
    isSendUnsubscribeNote: true,

    resetFooterTemplate() {
      this.emailFooterTemplate = undefined
      this.emailUnsubscribeTemplate = undefined;
      this.isFormDirty = false;
    },

    setIsFormDirty(isFormDirty) {
      this.isFormDirty = isFormDirty;
    },

    setEmailFooterTemplate(emailFooterTemplate) {
      this.emailFooterTemplate = emailFooterTemplate;
      this.setIsFormDirty(true);
    },

    setEmailUnsubscribeTemplate(emailUnsubscribeTemplate) {
      this.emailUnsubscribeTemplate = emailUnsubscribeTemplate;
      this.setIsFormDirty(true);
    },

    setIsSendUnsubscribeNote(isSendUnsubscribeNote) {
      this.isSendUnsubscribeNote = isSendUnsubscribeNote;
    },

    getEmailFooterSetting() {
      return (ApiService.get(ApiUrl.getEmailFooterSetting, "", Constants.ALERT_FETCH_FAILED).then(
        action(
          response => {
            this.setEmailFooterTemplate(JSON.parse(response.data.result.htmlFooterTemplate));
            this.setEmailUnsubscribeTemplate(JSON.parse(response.data.result.htmlUnsubscribeTemplate));
            this.setIsFormDirty(false);
            return Promise.resolve(response);
          }
        )
      ).catch(
        action(
          error => {
            return Promise.reject(error);
          }
        )
      ));
    },

    saveEmailFooterSetting() {
      const data = {
        htmlFooterTemplate: JSON.stringify(this.emailFooterTemplate),
        htmlUnsubscribeTemplate: JSON.stringify(this.emailUnsubscribeTemplate),
      };

      return (ApiService.edit(ApiUrl.updateEmailFooterSetting, data).then(
        action(
          response => {
            if (response && response.status === 200 && response.data && !response.data.isError) {
              this.setIsFormDirty(false)
              Alert.success("Changes is saved successfully");
            } else {
              Alert.error("Oops, Something went wrong! Please try again.");
            }
            return Promise.resolve(response.data);
          }
        )
      ).catch(
        action(
          error => {
            return Promise.reject(error);
          }
        )
      ));
    },

    getSendUnsubscribeNoteStatus() {
      return (ApiService.get(ApiUrl.getCompanyAdditionalInfo).then(
        action(
          response => {
            if (response && response.status === 200 && response.data && !response.data.isError) {
              this.isSendUnsubscribeNote = response.data.result?.isSendUnsubscribeNote;
            } else {
              Alert.error("Oops, Something went wrong! Please try again.");
            }
            return Promise.resolve(response.data);
          }
        )
      ).catch(
        action(
          err => {
            return Promise.reject(err);
          }
        )
      ));
    },

    saveSendUnsubscribeNoteStatus(isSendUnsubscribeNoteStatus) {
      const data = {
        isSendUnsubscribeNote: isSendUnsubscribeNoteStatus
      };

      return (ApiService.edit(ApiUrl.saveSendUnsubscribeNoteStatus, data).then(
        action (
          response => {
            if (response && response.status === 200 && response.data && !response.data.isError) {
              this.setIsSendUnsubscribeNote(data.isSendUnsubscribeNote);
            } else {
              Alert.error("Oops, Something went wrong! Please try again.");
            }
            return Promise.resolve(response.data);
          }
        )
      ).catch (
        action (
          err => {
            return Promise.reject(err);
          }
        )
      ));
    },

  }
);

export default emailFooterTemplateStore;
